import React, {createElement, useCallback, useContext} from 'react';
import {useHistory} from 'react-router-dom';
import {useQuery} from '../../../core/hooks/query.hook';
import {analyticsEvent} from '../../../utils/analytics';
import './transport.scss';
import {MapContext} from '../../../services/map-v2/map.context';
import {DataContext} from '../../../services/data-v2/data.context';

function TransportComponent(props: any) {

    const query = useQuery();
    const history = useHistory();
    const {pointer, map} = useContext(MapContext);
    const {realTimeWorker} = useContext(DataContext);
    const DataService = useContext(DataContext);

    const onClick = useCallback(async () => {
        analyticsEvent('Home', 'home_stationsearch_click');
        const coords = pointer || {lat: query.lat, lng: query.lng};
        const selectedTransportSlugs = props.transportSlugs;
        if (realTimeWorker) {
            realTimeWorker.activeTransportSlugs = selectedTransportSlugs;
        }
        if (realTimeWorker) {
            try {
                await realTimeWorker.updateAllSharedServicesRealTimes();
            } catch (error) {
                console.error('Error al ejecutar updateAllSharedServicesRealTimes:', error);
            }
        }
        if (map) {
            if (props.id === 4) {
                map.loadKmlLayer('https://opendata.ambmobilitat.cat/KML/noparking_moto_sh.kml');
            } else {
                map.removeKmlLayer();
            }
        }
        await DataService.handleNearbyServices(props.id);

        history.push(`/${pointer ? 'serveis-aprop' : 'close-stops'}?type=${props.id}${coords.lat && coords.lng ? `&lat=${coords.lat}&lng=${coords.lng}` : ''}`);

    }, [pointer, realTimeWorker, props.title, map]);

    return <div className="transport-box">
        <div className="transport-type">
            <button
                className={`transport-btn${!props.selected || props.selected.id === props.id ? ' active' : ''}`}
                disabled={props.disabled}
                onClick={onClick}
            >
                {createElement(props.icon)}
            </button>
        </div>
        <span className="transport-title">{props.title}</span>
    </div>;
}

export default TransportComponent;
